(() => {
  const dialog = document.getElementById('RingSizePickerModal');
  if (!dialog) return;
  let opener = null;
  let busy = false;
  let keyboardInteraction = false;

  const enableTriggers = (root) => {
    const buttons = root.matches?.('[data-ring-size-pending]')
      ? [root] : root.querySelectorAll('[data-ring-size-pending]');
    buttons.forEach((button) => {
      button.disabled = false;
      button.removeAttribute('data-ring-size-pending');
    });
  };
  enableTriggers(document);
  new MutationObserver((records) => {
    records.forEach((record) => record.addedNodes.forEach((node) => {
      if (node.nodeType === 1) enableTriggers(node);
    }));
  }).observe(document.body, { childList: true, subtree: true });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Tab' || event.key === 'Enter' || event.key === ' ' || event.key === 'Escape') keyboardInteraction = true;
  }, true);
  document.addEventListener('pointerdown', () => { keyboardInteraction = false; }, true);

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('.ProductItem__quickadd__trigger');
    if (!trigger) return;
    const owner = trigger.closest('[data-ring-size-picker-id]');
    const template = owner && document.querySelector(`template[data-ring-size-product="${owner.dataset.ringSizePickerId}"]`);
    if (!template) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (busy) return;
    opener = trigger;
    dialog.querySelector('.UiModal__Content').replaceChildren(template.content.cloneNode(true));
    trigger.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add('has-ring-size-picker');
    dialog.showModal();
  }, true);

  dialog.addEventListener('click', (event) => {
    if (event.target.closest('[data-action="close-sheet"]')) {
      if (!busy) dialog.close();
      return;
    }
    if (event.target === dialog && !busy) {
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    }
    const choice = event.target.closest('[data-ring-variant]');
    if (!choice || busy) return;
    const form = choice.closest('form');
    form.dataset.variantId = choice.dataset.ringVariant;
    form.querySelectorAll('[data-ring-variant]').forEach((button) => {
      button.setAttribute('aria-pressed', String(button === choice));
    });
    document.dispatchEvent(new CustomEvent('product-card:price-variant', { detail: { scope: form, variantId: choice.dataset.ringVariant } }));
    form.querySelector('[type="submit"]').disabled = false;
    form.querySelector('[data-ring-error]').hidden = true;
  });

  dialog.addEventListener('cancel', (event) => { if (busy) event.preventDefault(); });
  dialog.addEventListener('close', () => {
    document.documentElement.classList.remove('has-ring-size-picker');
    opener?.setAttribute('aria-expanded', 'false');
    if (opener?.isConnected) {
      if (keyboardInteraction) opener.focus({ preventScroll: true });
      else if (document.activeElement === opener) opener.blur();
    }
    opener = null;
  });

  dialog.addEventListener('submit', async (event) => {
    event.preventDefault();
    const form = event.target;
    if (busy || !form.dataset.variantId) return;
    busy = true;
    form.setAttribute('aria-busy', 'true');
    form.querySelector('[data-ring-error]').hidden = true;
    form.querySelectorAll('button').forEach((button) => { button.disabled = true; });
    try {
      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: form.dataset.variantId, quantity: 1 }] })
      });
      if (!response.ok) throw new Error('Cart add failed');
      busy = false;
      dialog.close();
      document.dispatchEvent(new CustomEvent('product:added', { detail: { quantity: 1 } }));
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    } catch {
      form.querySelector('[data-ring-error]').hidden = false;
    } finally {
      busy = false;
      form.removeAttribute('aria-busy');
      form.querySelectorAll('button').forEach((button) => { button.disabled = false; });
    }
  });
})();
